import React, { useMemo } from 'react'

import { useAccounts } from 'redux/hooks/Accounts'
import { useTranslation } from 'language/translator'

import FormSection from 'components_new/molecules/FormSection'
import SelectSearch, { Option } from 'components_new/molecules/SelectSearch'

import { formatUserOption } from 'utils/functions'

interface OwnersProps {
  onSubmit: (value: string[]) => void
  value: string[]
}

const Owners = (props: OwnersProps) => {
  const { onSubmit, value } = props

  const { t } = useTranslation()

  const { accounts, loading: accountsLoading } = useAccounts()

  const options: Option[] = accounts.map((account) => formatUserOption(account))

  const selected = useMemo(() => {
    return options.filter((option) => value.includes(option.id as string))
  }, [value])

  if (accountsLoading) return <>Laddar...</>

  return (
    <FormSection
      helperText={t('groups', 'group_owner_helper_text')}
      importance="required"
      size="small"
      title={t('global', 'owner')}
    >
      {/* {loading ? (
        <Skeleton height={64} variant="rounded" width="100%" />
      ) : ( */}
      <SelectSearch
        color="primary"
        closeOnSelect={true}
        disableClearable={true}
        error={value.length === 0}
        helperText={
          value.length === 0 ? t('groups', 'no_owner_error') : undefined
        }
        onChange={(value: Option[]) => {
          onSubmit(value.map((v) => v.id as string))
        }}
        multiple={true}
        options={options}
        selected={selected}
        size={'medium'}
        sort={true}
      />
    </FormSection>
  )
}

export default Owners
